/**
 *
 */
export const ellipsisHorizontal = {
    paths: [
        {
            d: 'M8 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM1.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=ellipsis-horizontal.js.map